import { render, staticRenderFns } from "./xuqiuSqC.vue?vue&type=template&id=18b096a1&scoped=true"
import script from "./xuqiuSqC.vue?vue&type=script&lang=js"
export * from "./xuqiuSqC.vue?vue&type=script&lang=js"
import style0 from "./xuqiuSqC.vue?vue&type=style&index=0&id=18b096a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b096a1",
  null
  
)

export default component.exports